import React from 'react';

import { Container, CountContainer, TabButton, TabHeader } from './TabBar.styles';
import { TabBarProps } from './TabBar.types';

export const TabBar: React.FC<TabBarProps> = ({ style, selectedTabId, tabs, onChange }) => {
  return (
    <Container data-testid="tab-bar" style={style}>
      <TabHeader>
        {tabs.map(tab => (
          <TabButton
            selected={tab.id === selectedTabId}
            key={tab.title}
            onClick={() => onChange?.(tab.id)}
          >
            {tab.icon && tab.icon}
            {tab.title}
            {tab.count >= 0 && <CountContainer>{tab.count}</CountContainer>}
          </TabButton>
        ))}
      </TabHeader>
      {tabs.find(tab => tab.id === selectedTabId).content}
    </Container>
  );
};
